/* eslint-disable padding-line-between-statements */

import { TranslatorContext, IntlContext } from '@jutro/locale';
import { MetadataContent } from '@jutro/legacy/uiconfig';
import { Currency as CurrencyField } from 'gw-components-platform-react';
import PropTypes from 'prop-types';
import moment from 'moment';
import _ from 'lodash';
import classNames from 'classnames';
import React, { useCallback, useContext, useState } from 'react';
import { CheckboxField } from '@jutro/legacy/components';
import messages from './InvoicesTable.messages';
import metadata from './InvoicesTable.metadata.json5';
import styles from './InvoicesTable.module.scss';

const showPastDueAlert = (items) => {
    
    if ( _.includes(items.invoiceStatus, 'due') && (items?.amountDue.amount > 0)) {
        return true;
    }
    return false;
};

 const renderFormattedCurrencyField = (item, index, property) => {
    const showAlert = showPastDueAlert(item);
    const classNameShowPastDueAlert = classNames({[styles.pastDueColorForCurrency]: showAlert });

    <CurrencyField
    id={`currency_${index}`}
    className={classNameShowPastDueAlert}
    value={item[property.id]}               
    readOnly
    hideLabel
    showOptional={false}
/>
    
    if (showAlert){
        return (
            <span  >
                <CurrencyField
                    id={`currency_${index}`}
                    className={classNameShowPastDueAlert}
                    value={item[property.id]}               
                    readOnly
                    hideLabel
                    showOptional={false}
                />
            </span>
        );
    }

    return (
        <span >
            <CurrencyField
                id={`currency_${index}`}
                value={item[property.id]}
                readOnly
                hideLabel
                showOptional={false}
            />
        </span>
    );
 }

const getFormattedCurrency = (item, index, property) => renderFormattedCurrencyField(item, index, property);

const getCell = (item, index, property) => {
     const classNameShowPastDueAlert = classNames({[styles.negativePastDueAlert]: showPastDueAlert(item)});
     return <span className={ classNameShowPastDueAlert }>{item[property.id]} </span>
}

function InvoicesTable(props) {
    const {
        invoiceSummary,
        selectedInvoices,
        onUpdateSelectedInvoices,
        showPaidDate,
        showSelect,
    } = props;

    const intl = useContext(IntlContext);
    const translator = useContext(TranslatorContext);
    const [preSelected, setPreSelected] = useState(false);
    // const [selectNewerInvoices, setSelectNewerInvoices] = useState(false);
    
    const getBillStatus = (item, index, property) => {
        const pastDueAlert = showPastDueAlert(item);
        const classNameShowPastDueAlert = classNames( {[styles.negativePastDueAlert]: pastDueAlert});
    
        if (item.paidStatus === 'fullypaid') {
            return <span className={classNameShowPastDueAlert}>{translator(messages.paid)}</span>;
        }

        if (pastDueAlert){
            return <span className={classNameShowPastDueAlert}>{translator(messages.pastDue)}</span>;
        }
        
        return {
            id: `typekey.InvoiceStatus.${item[property.id]}`,
            defaultMessage: item[property.id]
        }
    };

    const getFormattedDate = useCallback((item, index, property) =>{
        const classNameShowPastDueAlert = classNames({[styles.negativePastDueAlert]: showPastDueAlert(item)});       
        return <span className={ classNameShowPastDueAlert }>{ intl.formatDate(new Date(item[property.id]), {year: 'numeric', month: 'short',day: 'numeric'})} </span>
        }, [intl]
);

    function isOverDue(invoiceItem) {
        const currDate  = moment();
        if (!_.isEmpty(invoiceItem)) {
            const itemDate = moment(invoiceItem.dueDate);
            return invoiceItem.paidStatus === 'unpaid' && itemDate.isBefore(currDate, 'day');
        }
        return false;
    };

    const preSelectPastDueInvoices = useCallback(() =>{
             // PreSelected Invoices Logic         
        if (!preSelected){               
            const overdueInvoices = _.filter( invoiceSummary,  anInvoiceSummary =>  isOverDue(anInvoiceSummary));
            if (!_.isEmpty(overdueInvoices)){
                overdueInvoices.forEach((inv) => { 
                    selectedInvoices.push(inv.invoiceId);
                })
            }           
            onUpdateSelectedInvoices(selectedInvoices);
            setPreSelected(true);
        }
    }, [invoiceSummary, onUpdateSelectedInvoices, preSelected, selectedInvoices]);


    const changeSelectedInvoicesList = useCallback((value) => {
        // get the last selectedId index
        // const lastSelectedIdIndx = sids.length -1;
        // get the invoice details from here..
        const lastSelectedInv = invoiceSummary.find((f) => f.invoiceId === value);
        // get  the duedate from this invoice..
        const updateSelection = _.filter(invoiceSummary, inv => moment(inv.dueDate).isSameOrBefore(lastSelectedInv.dueDate));
        if (!_.isEmpty(updateSelection)){
            const addinvs=[];   
            updateSelection.forEach((inv) => { 
                if(inv.invoiceStatus === 'planned' || inv.invoiceStatus === 'billed' || inv.invoiceStatus === 'carriedforward' || inv.invoiceStatus === 'writtenoff'){
                        addinvs.push(inv.invoiceId);
                }              
            });
            
            if (!_.isEmpty(addinvs)){
                    onUpdateSelectedInvoices(addinvs);
            }              
        }
    }, [invoiceSummary, onUpdateSelectedInvoices]);

    const unSelectNewerInvoices = useCallback((sids, value) => {
        // match the list of selectedIds to the indexes..
        let newList = sids;
        let updatedList;
        
        const unselectedInv = invoiceSummary.find((f) => f.invoiceId === value);
        // get  the duedate from this invoice..
        const invoicesToBeRemoved = _.filter(invoiceSummary, inv => moment(inv.dueDate).isSameOrAfter(unselectedInv.dueDate));
        
        if (!_.isEmpty(invoicesToBeRemoved)){             
            if (!_.isEmpty(invoicesToBeRemoved)){           
                if (invoicesToBeRemoved.length === invoiceSummary.length){
                    // simply remove the selected ONE item
                    onUpdateSelectedInvoices([]);
                } else { 
                    invoicesToBeRemoved.forEach((itbr) =>{
                        updatedList = newList.filter( iter => iter !== itbr.invoiceId );
                         newList = updatedList;
                    });
                    // so lets update the selectedInvoiceList..
                    if (!_.isEmpty(newList)){
                      onUpdateSelectedInvoices(newList);
                    }
                }
            }
        }

    }, [invoiceSummary, onUpdateSelectedInvoices])

    const getCheckboxDataCell = useCallback(
        (item, index, property) => {
            const value = item[property.id];          
            // Past due invoices should come up preselected..
            preSelectPastDueInvoices();           
            const selectedIds = [...new Set(selectedInvoices)];         
            const isChecked = selectedIds.indexOf(value) > -1;
            return (
                <CheckboxField
                    id={`${property.id}_${index}`}
                    name={`${property.id}_${index}`}
                    value={isChecked}
                    onValueChange={selected => {
                        if (selected) {
                            selectedIds.push(value);
                            // Select older invoices
                            changeSelectedInvoicesList(value);
                        } else {
                            const updated = selectedIds
                                .filter( iter => iter !== value );
                            // Select newer invoices
                             unSelectNewerInvoices(updated, value);
                        }
                    }}
                />
            );
        },
        [changeSelectedInvoicesList, preSelectPastDueInvoices, selectedInvoices, unSelectNewerInvoices]
    );

    const overrideProps = {
        tablePaymentScheduleDetail: {
            data: invoiceSummary,
        },
        tablePaymentScheduleDetailLastPaymentDate: {
            visible: showPaidDate,
        },
        tablePaymentScheduleDetailPay: {
            visible: showSelect,
        },
    };

    const resolvers = {
        resolveClassNameMap: styles,
        resolveCallbackMap: {
            getFormattedDate,
            getBillStatus,
            getFormattedCurrency,
            getCell,
            getCheckboxDataCell,
        },
    };

    return (
        <MetadataContent
            uiProps={metadata.componentContent}
            overrideProps={overrideProps}
            {...resolvers}
        />
    );
}

InvoicesTable.propTypes = {
    invoiceSummary: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
    selectedInvoices: PropTypes.arrayOf(PropTypes.string),
    onUpdateSelectedInvoices: PropTypes.func,
    showSelect: PropTypes.bool,
    showPaidDate: PropTypes.bool,
};

InvoicesTable.defaultProps = {
    selectedInvoices: [],
    onUpdateSelectedInvoices: undefined,
    showSelect: false,
    showPaidDate: false,
};

export default InvoicesTable;
